var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{key:_vm.userId},[_c('v-container',{staticClass:"ma-0 pa-0 d-flex"},[_c('h1',[_vm._v("Рабочий стол")]),_c('v-spacer'),_c('stat-settings')],1),_c('months-charts'),_c('sites-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }